import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { proxyPageImages } from "../lib/imageProxy";
import GeneratedPageContent from "../components/GeneratedPageContent";
import DeactivatedNotice from "../components/DeactivatedNotice";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GeneratedPage() {
  const { pageId, subdomain } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPage();
  }, [pageId, subdomain]);

  const fetchPage = async () => {
    try {
      let response;
      if (subdomain) {
        response = await axios.get(`${API}/pages/subdomain/${subdomain}`);
      } else {
        response = await axios.get(`${API}/pages/${pageId}`);
      }
      setPage(proxyPageImages(response.data));
    } catch (error) {
      console.error("Failed to fetch page:", error);
      setError("Seite nicht gefunden");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Seite nicht gefunden</h1>
          <p className="text-slate-600">Diese Landingpage existiert nicht oder wurde entfernt.</p>
        </div>
      </div>
    );
  }

  if (page.is_deactivated) return <DeactivatedNotice company={page.company_name} />;
  return <GeneratedPageContent page={page} isPreview={false} />;
}
